import * as moment from 'moment';

export class DateUtils {
  static formatDateSk(date: string) {
    const format: string = 'DD. MMMM YYYY';
    let result = null;
    if (date) {
      result = moment(date).locale('sk').format(format);
    }
    return result;
  }
}
